export var ELoginSource;
(function (ELoginSource) {
    ELoginSource["NESTTRADER"] = "nesttrader";
})(ELoginSource || (ELoginSource = {}));
